@if (openBox) {
  <div class="bd-backdrop" (click)="goBack()">
    <div
      class="bd-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bd-title"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <header class="bd-header">
        <div class="bd-title-block">
          <h2 id="bd-title">✏️ Modifica scatola custom</h2>
          <p class="bd-subtitle">
            Aggiorna le dimensioni del collo n° <strong>{{ boxNo + 1 }}</strong>
          </p>
        </div>
        <button
          type="button"
          class="bd-close"
          aria-label="Chiudi"
          (click)="goBack()"
        >
          ×
        </button>
      </header>

      <!-- Body -->
      <div class="bd-body">
        <div class="bd-fields">
          <label class="bd-field">
            <span class="bd-field-label">Altezza (mm)</span>
            <input
              type="number"
              class="bd-field-input"
              [(ngModel)]="newBox.ts_box_height"
              [placeholder]="box.ts_box_height + ' mm'"
              min="0"
            />
          </label>

          <label class="bd-field">
            <span class="bd-field-label">Lunghezza (mm)</span>
            <input
              type="number"
              class="bd-field-input"
              [(ngModel)]="newBox.ts_box_length"
              [placeholder]="box.ts_box_length + ' mm'"
              min="0"
            />
          </label>

          <label class="bd-field">
            <span class="bd-field-label">Profondità (mm)</span>
            <input
              type="number"
              class="bd-field-input"
              [(ngModel)]="newBox.ts_box_depth"
              [placeholder]="box.ts_box_depth + ' mm'"
              min="0"
            />
          </label>

          <label class="bd-field">
            <span class="bd-field-label">Peso (kg)</span>
            <input
              type="number"
              class="bd-field-input"
              [(ngModel)]="newBox.ts_box_weight"
              [placeholder]="box.ts_box_weight + ' kg'"
              min="0"
              step="0.01"
            />
          </label>
        </div>
      </div>

      <!-- Footer -->
      <footer class="bd-footer">
        <button type="button" class="bd-btn bd-btn--cancel" (click)="goBack()">
          <i class="bx bx-x"></i> Annulla
        </button>
        <button
          type="button"
          class="bd-btn bd-btn--save"
          [disabled]="isSaveDisabled"
          (click)="validateBox()"
        >
          <i class="bx bx-check-circle"></i> Salva modifiche
        </button>
      </footer>
    </div>
  </div>
}
